/* src/app/invoice/setup/invoice-selections/invoice-selections.component.scss */
/*# sourceMappingURL=invoice-selections.component.css.map */
